<div [class]="messageType" class="messagebox">
  @if (messageType === 'received') {
    <strong class="sr-only"
    i18n="sr-only@@messageStatus.receive">Empfangen: </strong>
  }
  @if (messageType === 'sent') {
    <strong class="sr-only" i18n="sr-only@@messageStatus.sent">Gesendet: </strong>
  }
  @if (messageType === 'system') {
    <strong class="sr-only" i18n="sr-only@@messageStatus.system">System: </strong>
  }
  @if (timestamp) {
    <p class="messagebox__date">
      @if (messageType === 'sent') {
        <span i18n="@@employment.conversation.you">Du, </span>
      }
      @if (messageType === 'received') {
        <span>{{ companionName }}, </span>
      }
      {{ timestamp | date : "dd.MM.yyyy 'um' HH:mm 'Uhr'" }}
    </p>
  }
  <ng-content></ng-content>
</div>
